import api from './api';

api.defaults.baseURL = process.env.BASE_URL;

export default api;
